<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">野心はコーチできない</h1>
                <span class="meta"> Posted in April 2021 </span>

                <p class="author-info ">Mark Bivens is a Silicon Valley native and former entrepreneur, having started three companies before becoming a VC. He is the Managing Partner of Shizen Capital (formerly known as Tachi.ai Ventures) in Japan. You can read more on his blog at <a href="http://markbivens.com">http://rude.vc</a> or follow him on Twitter <a href="https://twitter.com/markbivens">@markbivens</a>.</p>

                <figure>
                  <img class="img-fluid" src="img/blog/card/cannotcoachheight.png" alt="">
                </figure>
                
                <p> Red Auerbach（レッド・アワーバック）——1950－60年代に Boston Celtics（ボストンセルティックス）を9回の NBA チャンピオンに導いた名将だ。彼の有名な言葉に、「身長はコーチできない」というものがある。これは、なぜドラフトで背が高いだけでスキルの低い選手を指名するのかと、記者から質問を受けた際に放った言葉だ。つまり、パス、ドリブル、シュート、リバウンドショットなど、プレーを指導することは出来るが、身体的特性は教えようがないということである。</p>

                <p>起業家にとってこの表現に相当するのは、「野心はコーチできない」ということだ。</p>

                <p>私は直近の Clubhouse の資金調達ラウンドに関するスタートアップ業界の反応を見て、この言葉を思い出した。</p>

                <p>先般、Clubhouse はシリーズ A で Andreesen Horowitz から1,000万米ドルを調達し、そのうちの200万米ドルはセカンダリーとして創業者に直接支払われた。200万米ドルが創業者の懐に入るということで、本件は注目を集めた。</p>

                <p>これは私のキャリアがシリコンバレーよりもヨーロッパで長いからかもしれないが、このようなディールストラクチャーは、一見悪意があるように見えても、特別批判に値するものではないと思っている。</p>

                <p>ヨーロッパのスタートアップ創業者は、決して貧困層ではないものの、特権階級出身の創業者はほとんどいない。今まで会ってきた創業者のほとんどは、そこそこの給料（とりわけ高い税金と社会保障費を差し引くと）をもらいつつも、保有株式のキャピタルゲインも限定的で長年苦労してきている。</p>

                <p>アメリカとは対照的な広範囲な社会保障は起業家のセーフティネットとして機能し、さまざまな層の人々が起業する選択肢を選ぶことを可能にした。このような社会的背景もあり、ヨーロッパでは「のるかそるか」というギャンブル的なメンタリティをもった起業家は非常に少ない。</p>

                <p>こうした背景を鑑みると、長年少ない金銭的リターンで努力してきた起業家が、セカンダリーラウンドで恩恵を受けるのは、不自然なことではないと私は思っている。200万米ドルよりも少ない額、且つシリーズ A ではなくもっとレイターステージだが、私も同様の取引は複数回行っている。</p>

                <p>私の経験では、このような取引は幾つかのケースでは創業者をモチベートし、更なる成長を促すことに寄与し、別のケースでは成長に結びつかず、他の投資家とのミスアラインメントを引き起こした。</p>

                <p>そしてこのような経験を通して私が学んだことは、別の変数、すなわち創業者の野心をコントロールすることが重要という点である。</p>

                <p>例えば創業者のパフォーマンスを高める上で、家庭の生計といった外部要因が制約となっている場合、セカンダリーラウンドを通して負担を軽減してあげることが企業成長にポジティブに働くことは証明されている。</p>

                <p>野心は生ものであり、私を含む投資家が提供できるサポートとは全く別物である。アワーバックが若い選手をコーチしてきたように、会社のストラクチャー、ファイナンス、マーケティング、リクルーティング、ピッチ、資金調達、交渉、Exit 等々はスキルとして育成できる。しかし、野心はコーチできない。</p>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
